import type { Policy } from '@cartwhl/common/appletPolicy';

import StudioShellLayout from '../StudioShellLayout';
import BatchGeneration from './components/BatchGeneration';

const applet = {
  id: 'generation',
  path: '/generation',
  paths: [
    '/generation',
    '/generation/:id',
    '/swing',
    '/swing/:id',
    '/batch-generation',
    '/batch-generation/:id',
    '/batch-swing',
    '/batch-swing/:id',
  ],
  label: 'Motion Generation',
  description: 'Text-to-motion generation',
  dashboard: {
    imageSrc:
      'https://resources.getcartwheel.com/share/demo-videos/swing_square_first_frame.jpg',
    imageAlt: '',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/swing_square_output.webm',
    title: 'Swing',
    description: 'Text-to-motion. Generate any number of motions from prompts.',
    order: 20,
  },
  policy: {
    requiresLoggedIn: true,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: BatchGeneration,
  layout: StudioShellLayout,
};

export default applet;
